import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import router from '@/router';
const NetworkError = '网络连接异常,请稍后再试!';
const UnKnowError = '未知错误!';
const UnauthorizedError = '未授权!';
const pending:any = {}; // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
const { CancelToken } = axios;
const pendingHandler = (key: string, isRequest = false) => {
  if (pending[key] && isRequest) {
    pending[key]('取消重复请求');
  }
  delete pending[key];
};

const getRequestIdentify = (config:AxiosRequestConfig, isReuest = false) => {
  const url = config.url ?? '';
  const baseURL = config.baseURL ?? '';
  let result = url;
  if (isReuest) {
    result = baseURL + url;
  }
  result = config.method === 'get' ? encodeURIComponent(result + JSON.stringify(config.params)) : encodeURIComponent(result + JSON.stringify(config.data));
  return result;
};

const axiosInstance:AxiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}/rest/v1/master`,
  headers: {
    Accept: 'application/json',
    get: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
    post: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    put: {
      'Content-Type': 'application/json;charset=utf-8',
    },
  },
  // 是否跨站点访问控制请求
  withCredentials: false,
  timeout: 30000,
  // transformRequest: [(data) => JSON.stringify(data),
  // ],
  transformResponse: [(data) => {
    if (typeof data === 'string' && data.startsWith('{')) {
      return JSON.parse(data);
    }
    return data;
  }],
});

// axios实例拦截响应
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // 把已经完成的请求从 pending 中移除
    const requestData = getRequestIdentify(response.config);
    pendingHandler(requestData);
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      router.push('/Login');
      return Promise.reject(UnauthorizedError);
    }
    if (error?.message === '取消重复请求') {
      return Promise.reject('取消重复请求');
    }
    else if (error?.message === 'Network Error') {
      return Promise.reject(NetworkError);
    }
    return Promise.reject(UnKnowError);
  },
);

// axios实例拦截请求
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const newConfig = config;
    newConfig.headers.Authorization = '';
    const token = sessionStorage.imToken;
    if (token) {
      newConfig.headers.Authorization = `Bearer ${token}`;
    }
    const requestData = getRequestIdentify(config, true);
    pendingHandler(requestData, true);
    newConfig.cancelToken = new CancelToken((cancelFn) => {
      pending[requestData] = cancelFn;
    });
    return newConfig;
  },
);

export default axiosInstance;
